module.exports = __webpack_public_path__ + "static/media/3.17_preview.20847899.png";